import { useCallback, useSyncExternalStore } from "react";

import type { RelayClient, RelayStatus } from "./client";

/** The relay's connection status as React state; no relay reads as closed. */
export function useRelayStatus(relay: RelayClient | undefined): RelayStatus {
  const subscribe = useCallback(
    (changed: () => void) => {
      if (!relay) return () => {};
      const off = relay.onStatus(changed);
      return () => {
        off();
      };
    },
    [relay],
  );
  return useSyncExternalStore(subscribe, () => relay?.currentStatus ?? "closed");
}
